/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * An enumeration.
 */
export var AccountingProviderName;
(function (AccountingProviderName) {
    AccountingProviderName["QBO"] = "qbo";
    AccountingProviderName["CODAT"] = "codat";
    AccountingProviderName["FREETEXT"] = "freetext";
    AccountingProviderName["XERO"] = "xero";
    AccountingProviderName["QBD"] = "qbd";
    AccountingProviderName["SAGE"] = "sage";
    AccountingProviderName["NETSUITE"] = "netsuite";
    AccountingProviderName["R365"] = "r365";
    AccountingProviderName["GREAT_PLAINS"] = "great_plains";
    AccountingProviderName["DEFAULT"] = "default";
})(AccountingProviderName || (AccountingProviderName = {}));
